import { FieldSchema } from 'Listrak.Customer.Segmentation.Api.Client';
import { DateTime } from 'luxon';

export const textFormatter = (values: string[]): string => {
  return values.length > 0 
    ? (values[0].length > 42 ? `${values[0].substring(0, 42)}...` : values[0])
    : '';
}

export const formattedNumber = (x: string): string => {
  const num = parseFloat(x);
  if (isNaN(num)) { return '' }
  return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 4 });
}

export const singleNumericFormatter = (values: string[]): string => {
  if (values.length === 0) { return '' }
  return formattedNumber(values[0]);
}

export const rangeNumericFormatter = (values: string[]): string => {
  return values.length > 0 ? `${formattedNumber(values[0])} and ${formattedNumber(values[1])}` : '';
}

export const offsetRelativeDateFormatter = (values: string[]): string => {
  const start = values.length > 0 ? values[0] : '';
  if (start === '') return '';

  return `${start.replace('-', '')} Days Ago`;
}

export const singleAbsoluteDateFormatter = (values: string[]): string => {
  const startDate = values.length > 0 ? values[0] : '';
  if (startDate === '') return '';

  const formattedStartDate = DateTime.fromISO(startDate).toLocaleString(DateTime.DATE_SHORT);
  return formattedStartDate;
}

export const rangeAbsoluteDateFormatter = (values: string[]): string => {
  const startDate = values.length > 0 ? values[0] : '';
  const endDate = values.length > 0 ? values[1] : '';
  if (startDate === '' || endDate === '') return '';

  const formattedStartDate = DateTime.fromISO(startDate).toLocaleString(DateTime.DATE_SHORT);
  const formattedEndDate = DateTime.fromISO(endDate).toLocaleString(DateTime.DATE_SHORT);

  return `${formattedStartDate} and ${formattedEndDate}`;
}

export const rangeAbsoluteDateFormatterMonthDay = (values: string[]): string => {
  const startDate = values.length > 0 ? values[0] : '';
  const endDate = values.length > 0 ? values[1] : '';
  if (startDate === '' || endDate === '') return '';

  const formattedStartDate = DateTime.fromISO(startDate).toLocaleString(DateTime.DATE_SHORT).split('/').filter((x: string) => x.length < 3).join('/');
  const formattedEndDate = DateTime.fromISO(endDate).toLocaleString(DateTime.DATE_SHORT).split('/').filter((x: string) => x.length < 3).join('/');

  return `${formattedStartDate} and ${formattedEndDate}`;
}

export const singleRelativeDateFormatter = (values: string[]): string => {
  const start = values.length > 0 ? values[0] : '';
  if (start === '') return '';

  return start === '-365' ? 'Year' : start !== '0' ? `${start.replace('-', '')} Days` : '';
}

export const rangeRelativeDateFormatter = (values: string[]): string => {
  const [ start, end ] = values;
  if (!start || !end) return '';
  const startsWithNegative = start.startsWith('-');

  return `${startsWithNegative ? 'Was Between' : 'Is Within the Next'} ${start.replace('-', '')} and ${end.replace('-', '')} Days${startsWithNegative ? ' Ago' : ''}`;
}

export const valueSelectionFormatter = (values: string[], ruleSchema: FieldSchema): string => {
  return values.length > 0 ? ruleSchema.accepts.values.find((v) => v === values[0]) : '';
}
